import { LayoutGrid, ListChecks, ShieldCheck, Sparkles } from 'lucide-react';
import FormBuilder from '../../components/FormBuilder';

// Form Ekle sayfası — kurumsal stilde sunum katmanı; FormBuilder mantığına dokunulmaz.
export default function FormCreatePage({ createForm }) {
  return (
    <section className="form-create-page">
      {/* Kurumsal başlık alanı */}
      <header className="form-create-hero">
        <div className="form-create-hero-content">
          <span className="form-create-eyebrow">
            <Sparkles size={14} /> Form Tasarım Stüdyosu
          </span>
          <h1>Form Ekle</h1>
          <p>
            Bölümler oluşturun, alan tiplerini ve doğrulamaları belirleyin, dosya yükleme
            kurallarını yapılandırın. Hazırladığınız şablon, atadığınız kullanıcılar tarafından
            anında doldurulabilir hale gelir.
          </p>
        </div>
        <div className="form-create-hero-glow" aria-hidden="true" />
      </header>

      {/* Yardımcı ipucu kartları */}
      <div className="form-create-tips">
        <article className="form-create-tip">
          <span className="form-create-tip-icon"><LayoutGrid size={18} /></span>
          <div>
            <h4>Bölümlerle gruplayın</h4>
            <p>İlgili alanları aynı başlık altında toplayarak doldurma deneyimini sadeleştirin.</p>
          </div>
        </article>
        <article className="form-create-tip">
          <span className="form-create-tip-icon"><ListChecks size={18} /></span>
          <div>
            <h4>Doğru alan tipini seçin</h4>
            <p>Metin, sayı, tarih, seçim, dosya ve fotoğraf alanları için uygun kuralları belirleyin.</p>
          </div>
        </article>
        <article className="form-create-tip">
          <span className="form-create-tip-icon"><ShieldCheck size={18} /></span>
          <div>
            <h4>Zorunlulukları unutmayın</h4>
            <p>Kritik alanları zorunlu işaretleyerek eksik gönderimleri en baştan engelleyin.</p>
          </div>
        </article>
      </div>

      {/* Form yapılandırıcı kartı */}
      <div className="form-create-builder">
        <div className="form-create-builder-header">
          <div>
            <h2>Form Yapılandırıcı</h2>
            <p className="muted">Bölümleri ve alanları sürükle-bırak ile düzenleyin.</p>
          </div>
        </div>
        <div className="form-create-builder-body">
          <FormBuilder onSave={createForm} />
        </div>
      </div>
    </section>
  );
}